import { request, errHandler } from "./heimdall";
import store from "../store";

export function getSiteTypes() {
  return request
    .get(`/types`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getSiteType(id) {
  return request
    .get(`/types/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}
